module.exports = __webpack_public_path__ + "static/img/14068B_1_2_C_20240430_LC.b570182.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14068B_1_2_C_20240430_LC.png
// module id = h4Ba
// module chunks = 0